import { createContext } from 'react';

export const ParetoChartContext = createContext(null);
